import { ResponseType } from '../types';

interface ParseConfig {
  responseType?: ResponseType;
}

export async function parseResponse<T>(
  response: Response,
  config: ParseConfig = {}
): Promise<T> {
  if (response.status === 204) {
    return {} as T;
  }

  const contentType = response.headers.get('content-type');

  switch (config.responseType) {
    case 'blob':
      return (await response.blob()) as T;

    case 'text':
      return (await response.text()) as T;

    default:
      if (contentType?.includes('application/json')) {
        return (await response.json()) as T;
      }

      return (await response.text()) as unknown as T;
  }
}
